'use client';

/**
 * Captura erros no layout raiz (ex.: falha ao conectar ao banco no generateMetadata).
 * Deve definir seu próprio <html> e <body>.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="pt-BR">
      <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif', background: '#f9fafb' }}>
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
            textAlign: 'center',
          }}
        >
          <p style={{ fontSize: '3rem', fontWeight: 700, color: '#fca5a5', marginBottom: '0.5rem' }}>
            Erro do sistema
          </p>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 600, color: '#1f2937', marginBottom: '0.5rem' }}>
            Algo deu errado
          </h1>
          <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>
            Não foi possível carregar a aplicação. Tente novamente ou entre em contato com o suporte.
          </p>
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              onClick={() => reset()}
              style={{
                padding: '0.625rem 1.25rem',
                backgroundColor: '#2563eb',
                color: 'white',
                fontWeight: 500,
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
              }}
            >
              Tentar novamente
            </button>
            <a
              href="/"
              style={{
                padding: '0.625rem 1.25rem',
                border: '1px solid #d1d5db',
                color: '#374151',
                fontWeight: 500,
                borderRadius: '0.5rem',
                textDecoration: 'none',
              }}
            >
              Voltar ao início
            </a>
          </div>
        </div>
      </body>
    </html>
  );
}
